import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SignUp() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();


  async function signupUser(event) {
    event.preventDefault();
    try {
      console.log(
            "username", username,
            "password", password,
      )
      const response = await fetch('https://fitnesstrac-kr.herokuapp.com/api/users/register', {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          
            username: username,
            password: password,
          
        }),
      });
      let result = await response.json();
      console.log (result)
      if (result.success) {
        setSuccessMessage(result.data.message);
        setTimeout(() => {
            navigate("/login");
          }, 1000);
        }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="form-container">
      <form onSubmit={(event) => signupUser(event)}>
        <h1>Sign Up</h1>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        <button type="submit">Sign Up</button>
        <div className="signup-message">
          Already have an account? <a href="/Login">Login</a>
        </div>
        {successMessage && <h3>{successMessage}</h3>}
      </form>
    </div>
  );
}